import React, { useState } from 'react'
import { UpgradeCreditServ } from '../../Services/Settings';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';


const UpgradeDetails: React.FunctionComponent<{}> = (props) => {

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [colorSnackbar, setColorSnackbar] = useState<any>("");
    const [message, setMessage] = useState<string>();
    const { t } = useTranslation();
    const plans = ["silver", "gold", "platinum"];


    const Subscribe = () => {
        UpgradeCreditServ().then((resp) => {
            setColorSnackbar("success")
            setOpenSnackbar(true)
            setMessage(resp.meessage)
        }).catch((error) => {
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage(error.response.data.message)
        })
    }

    const handleCloseSnackbar = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    return (

        <>
            <div className='flex-column d-flex justify-content-center align-items-center mb-4'>
                <div className='text-center'>
                    <h2 className='title-24  mb-4 font-32'>{t("upgrade.changePlan")}</h2>
                </div>
                <div className="tabs padd-2-0 width-231">
                    <button className={`tab color-black width-110 para-Gilroy-16 cursor-p tab-upgrade-active`}>
                        {t("home.monthly").charAt(0).toUpperCase() + t("home.monthly").slice(1)}
                    </button>
                    <button className={`tab color-black width-110 para-Gilroy-16 cursor-p `} >
                        {t("home.yearly").charAt(0).toUpperCase() + t("home.yearly").slice(1)}
                    </button>
                </div>
            </div>

            <div className="row mt-2">
                {plans.map((plan, idx) => (
                    <div className={`col-md-4 mb-3 ${plan === "gold" ? "flex-column d-flex align-items-center justify-content-center" : "marg-price"}`} key={plan}>
                        {plan === "gold" && (
                            <div className='butt-subscribe back-22C55E color-FFFFFF' style={{ borderRadius: "10px 10px 0px 0px", width: "10rem" }}>
                                {t("upgrade.recommended")}
                            </div>
                        )}
                        <div className="card-pricing-1 back-subscribe">
                            <div className='d-flex justify-content-between align-items-center mb-3'>
                                {/* Place your SVG here if needed */}
                                <button className="button-pricing-1 color-131143">
                                    {t(`upgrade.plans.${plan}.name`)}
                                </button>
                            </div>
                            <h4 className='h-price color-FFFFFF mb-3'>
                                {t(`upgrade.plans.${plan}.price`)}
                                <span className='color-FFFFFF'>{t(`upgrade.plans.${plan}.per`)}</span>
                            </h4>
                            <button type="button" className='butt-subscribe back-FFFFFF color-black mb-3' onClick={Subscribe}>
                                {t("upgrade.subscribe")}
                            </button>
                            <div className="padd-15 border-8 back-FFFFFF" >
                                <p className='para-Gilroy-16 bold-400 color-18181B'>
                                    {t("upgrade.whatsIncluded")}
                                </p>
                                {(t(`upgrade.plans.${plan}.features`, { returnObjects: true }) as string[]).map((feature, i) => (
                                    <p className='para-Gilroy-16 bold-400 color-18181B' key={i}>
                                        {plan !== "gold" ? <svg width="25" height="25" className='marg-right-10' viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.5566 21.2051C17.5271 21.2051 21.5566 17.1756 21.5566 12.2051C21.5566 7.23452 17.5271 3.20508 12.5566 3.20508C7.58608 3.20508 3.55664 7.23452 3.55664 12.2051C3.55664 17.1756 7.58608 21.2051 12.5566 21.2051Z" fill="#F97316" />
                                            <path d="M16.6816 9.95508L11.1785 15.2051L8.43164 12.5801" stroke="black" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                            :
                                            <svg width="25" height="25" className='marg-right-10' viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12.5566 21.2051C17.5271 21.2051 21.5566 17.1756 21.5566 12.2051C21.5566 7.23452 17.5271 3.20508 12.5566 3.20508C7.58608 3.20508 3.55664 7.23452 3.55664 12.2051C3.55664 17.1756 7.58608 21.2051 12.5566 21.2051Z" fill="#2DD881" />
                                                <path d="M16.6816 9.95508L11.1785 15.2051L8.43164 12.5801" stroke="black" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>}
                                        {feature}
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <Snackbar
                open={openSnackbar}
                onClose={handleCloseSnackbar}
                autoHideDuration={10000}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={colorSnackbar || "info"}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>

        </>
    )
}

export default UpgradeDetails